module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"submit_new_idea":"Submit New Idea","popularity":"Popularity","be_first_submit_ideas":"Be the first to submit new ideas"},"id":{"submit_new_idea":"Tambah Kritik dan Saran","popularity":"Popularitas","be_first_submit_ideas":"Jadilah yang pertama mengirimkan ide-ide baru"}}')
  delete Component.options._Ctor
}
